import React from "react";
import { useTranslation } from "react-i18next";
import { useSpeech } from "react-text-to-speech";

// MUI Components
import IconButton from "@mui/material/IconButton";

// Icons
import { MdContentCopy } from "react-icons/md";
import { AiOutlineLike, AiOutlineDislike } from "react-icons/ai";
import { HiOutlineVolumeUp, HiOutlineVolumeOff } from "react-icons/hi";
import { FiRefreshCcw } from "react-icons/fi";

// Styles
import styles from "./style.module.scss";

const AssistantMessage: React.FC = () => {
  // Hooks
  const { t } = useTranslation();

  const {
    Text,         // Component that renders and highlights the spoken text
    speechStatus, // "started", "paused", etc.
    start: startSpeech,        // Function to start speech
    // pause,        // Function to pause
    stop: stopSpeech,         // Function to stop
  } = useSpeech({
    text: 'Hello, world!',
    highlightText: true,
    highlightMode: 'word',
    highlightProps: {
      className: styles.highlightedText
    },
    volume: 1,
    rate: 1,
    pitch: 1,
    voiceURI: 'urn:moz-tts:osx:com.apple.voice.compact.en-GB.Daniel',
  });

  const handleCopy = () => {
    navigator.clipboard.writeText("Hello, world!");
  }

  const handleLike = () => {
  }

  const handleDislike = () => {
  }

  const handleTextToSpeech = () => {
    if (speechStatus === "started") {
      stopSpeech();
    } else {
      startSpeech();
    }
  }

  const handleRefresh = () => {
  }


  return (
    <div className={styles.root}>
      <div className={styles.content}>
        <Text />
      </div>

      <div className={styles.action_buttons}>
        <IconButton onClick={handleCopy}>
          <MdContentCopy />
        </IconButton>

        <IconButton>
          <AiOutlineLike />
        </IconButton>

        <IconButton>
          <AiOutlineDislike />
        </IconButton>

        <IconButton onClick={handleTextToSpeech}>
          {speechStatus === "started" ? <HiOutlineVolumeOff /> : <HiOutlineVolumeUp />}
        </IconButton>

        <IconButton>
          <FiRefreshCcw />
        </IconButton>
      </div>
    </div>
  )
};

export default AssistantMessage;
